Controller.$inject = [];

function Controller() {

}

export function HuiProgressTrack() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            direction: '@',
            sizing: '@',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            'bar': '?huiProgressBar'
        },
        template: ($element, $attrs) => {
            return `
                <div class="hui-progress-track-container"
                     ng-class="[$huiCtrl.direction, $huiCtrl.sizing || 'md']">
                    <div class="hui hui-progress-track" ng-transclude ng-transclude-slot="bar"></div>
                </div>
            `;
        }
    }
}